<div class="d-flex flex-column align-items-center">
  <mat-icon svgIcon="{{ data.icon }}" class="popup-icon"></mat-icon>

  <span>{{ data.text }}</span>

  <button matButton="elevated" class="primary" (click)="closeCustomDialog()">OK</button>
</div>

<lib-full-screen-loading [isShown]="isFullscreenLoaderShown"></lib-full-screen-loading>
